import React, { useEffect, useState } from "react";
import { FiMail, FiLock, FiArrowLeft } from "react-icons/fi";
import { VscEyeClosed } from "react-icons/vsc";
import { RxEyeOpen } from "react-icons/rx";
import logo from "../assets/new images/logo.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import apiKey from "../config/apiKey";
import { toast } from "react-toastify";

const StudentFormLogin = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrors({});
    try {
      const res = await axios.post(
        `${apiKey}/api/edolutions/teacher/login`,
        formData
      );
      localStorage.setItem("edo-teacher", JSON.stringify(res.data.data));
      toast.success("Mentor Login Successfully", {
        position: "bottom-right",
        autoClose: 3500,
        theme: "colored",
        style: { backgroundColor: "#2A3A54", color: "#fff" },
      });
      navigate(props.redirectTo || "/mentor/profile");
    } catch (err) {
      if (err?.response?.data?.errors) setErrors(err.response.data.errors);
      else setErrors({ general: "Invalid credentials" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("edo-teacher");
    if (user) navigate(props.redirectTo || "/mentor/profile");
  }, [navigate, props.redirectTo]);

  return (
    <div className="relative min-h-screen w-full grid place-items-center overflow-hidden">
      {/* Soft peach gradient + blobs */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FFF4EE] via-[#FFF8F4] to-[#FFEFE7]" />
      <div className="pointer-events-none absolute -left-24 -top-24 w-[38rem] h-[38rem] rounded-full bg-[#FFB899]/25 blur-3xl" />
      <div className="pointer-events-none absolute -right-28 bottom-0 w-[42rem] h-[42rem] rounded-full bg-[#FFD9C9]/30 blur-3xl" />

      <div className="relative w-full max-w-xl px-5">
        {/* Back link */}
        <div className="mb-2 md:pl-11">
          <NavLink
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#6B7280] hover:text-[#111827]"
          >
            <FiArrowLeft className="h-4 w-4" />
            Back to Home
          </NavLink>
        </div>

        {/* Card */}
        <div className="max-w-md mx-auto rounded-3xl border border-[#F7C9B7] bg-white/90 shadow-[0_10px_40px_-15px_rgba(17,24,39,0.15)] px-6 py-8 md:px-10 md:py-10">
          {/* Logo pill */}
          <div className="mx-auto -mt-3 mb-3 w-16 h-16 grid place-items-center rounded-2xl bg-white shadow-xl shadow-orange-600/30">
            <img src={logo} alt="logo" className="w-10 h-10 object-contain" />
          </div>

          {/* Heading */}
          <div className="text-center">
            <h1 className="text-3xl md:text-[32px] font-extrabold">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]">
                Welcome Back!
              </span>
            </h1>
            <p className="mt-2 text-sm text-[#6B7280]">
              Continue inspiring and guiding the next generation
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="mt-8 space-y-5">
            {errors.general && (
              <div className="rounded-md bg-red-50 text-red-700 text-sm px-3 py-2">
                {errors.general}
              </div>
            )}

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Email Address
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 grid place-items-center">
                  <FiMail className="h-4 w-4 text-[#9CA3AF]" />
                </span>
                <input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="w-full rounded-xl border border-[#E5E7EB] bg-white pl-10 pr-3 py-3 text-[15px] outline-none focus:border-[#EE5F2B] focus:ring-2 focus:ring-[#EE5F2B]/20 transition"
                />
              </div>
              {errors.email && (
                <p className="text-xs text-red-600 mt-1">{errors.email}</p>
              )}
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-[#111827] mb-2">
                Password
              </label>
              <div className="relative">
                <span className="absolute inset-y-0 left-3 grid place-items-center">
                  <FiLock className="h-4 w-4 text-[#9CA3AF]" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  onChange={handleChange}
                  placeholder="Enter your password"
                  className="w-full rounded-xl border border-[#E5E7EB] bg-white pl-10 pr-11 py-3 text-[15px] outline-none focus:border-[#EE5F2B] focus:ring-2 focus:ring-[#EE5F2B]/20 transition"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((s) => !s)}
                  className="absolute inset-y-0 right-2 px-2 grid place-items-center text-[#6B7280] hover:text-[#111827]"
                >
                  {showPassword ? (
                    <RxEyeOpen className="h-5 w-5" />
                  ) : (
                    <VscEyeClosed className="h-5 w-5" />
                  )}
                </button>
              </div>
              {errors.password && (
                <p className="text-xs text-red-600 mt-1">{errors.password}</p>
              )}
              <div className="mt-2 text-right">
                <Link
                  to={props.forgetpath || "/mentees/forgot-password"}
                  className="text-xs text-[#EE5F2B] hover:underline"
                >
                  Forgot password?
                </Link>
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full rounded-xl py-3.5 text-white font-semibold shadow-sm transition
                ${isLoading ? "opacity-60 cursor-not-allowed" : "hover:shadow-md"}
                bg-[#EE5F2B]
              `}
            >
              {isLoading ? (
                <span className="inline-flex items-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0A12 12 0 000 12h4z"
                    />
                  </svg>
                  Signing in…
                </span>
              ) : (
                "Sign In"
              )}
            </button>

            {/* Footer */}
            <p className="text-center text-sm text-[#6B7280]">
              Don’t have an account?{" "}
              <Link
                to={props.path || "/mentees/signup"}
                className="text-[#EE5F2B] font-semibold hover:underline"
              >
                Sign up
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StudentFormLogin;
